export enum TooltipPlacement {
  LEFT = 'left',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  TOP = 'top',
  AUTO = 'auto',
}
